import { http, HttpResponse } from 'msw';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

let nextFlagId = 5;

let featureFlags: Array<Record<string, unknown>> = [
  {
    id: 1,
    name: 'enable_live_mode',
    enabled: false,
    description: 'Enable LIVE execution mode for bots',
    created_at: '2026-01-01T00:00:00Z',
    updated_at: '2026-01-01T00:00:00Z',
  },
  {
    id: 2,
    name: 'enable_demo_mode',
    enabled: true,
    description: 'Enable interactive demo mode for visitors',
    created_at: '2026-02-15T10:00:00Z',
    updated_at: '2026-02-15T10:00:00Z',
  },
  {
    id: 3,
    name: 'enable_advanced_analytics',
    enabled: true,
    description: 'Show advanced bot analytics tab with execution quality metrics',
    created_at: '2026-02-01T00:00:00Z',
    updated_at: '2026-03-01T12:00:00Z',
  },
  {
    id: 4,
    name: 'enable_key_rotation',
    enabled: false,
    description: 'Enable API key rotation workflow for venue connections',
    created_at: '2026-03-01T00:00:00Z',
    updated_at: '2026-03-01T00:00:00Z',
  },
];

export const demoFeatureFlagsHandlers = [
  // ── List feature flags ────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/feature-flags`, () => {
    return HttpResponse.json({
      items: featureFlags,
      total: featureFlags.length,
      limit: 50,
      offset: 0,
    });
  }),

  // ── Create feature flag ───────────────────────────────────────────────────
  http.post(`${BASE}/api/v1/feature-flags`, async ({ request }) => {
    const body = (await request.json()) as Record<string, unknown>;
    const created = {
      id: nextFlagId++,
      name: (body['name'] as string) ?? 'new_flag',
      enabled: (body['enabled'] as boolean) ?? false,
      description: (body['description'] as string) ?? '',
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    };
    featureFlags = [...featureFlags, created];
    return HttpResponse.json(created, { status: 201 });
  }),

  // ── Update feature flag ───────────────────────────────────────────────────
  http.patch(`${BASE}/api/v1/feature-flags/:id`, async ({ request, params }) => {
    const id = Number(params['id']);
    const body = (await request.json()) as object;
    featureFlags = featureFlags.map((f) =>
      f.id === id ? { ...f, ...body, updated_at: new Date().toISOString() } : f,
    );
    const updated = featureFlags.find((f) => f.id === id);
    return HttpResponse.json(updated);
  }),

  // ── Delete feature flag ───────────────────────────────────────────────────
  http.delete(`${BASE}/api/v1/feature-flags/:id`, ({ params }) => {
    const id = Number(params['id']);
    featureFlags = featureFlags.filter((f) => f.id !== id);
    return new HttpResponse(null, { status: 204 });
  }),

  // ── Check feature flag by name ────────────────────────────────────────────
  http.get(`${BASE}/api/v1/feature-flags/:name/check`, ({ params }) => {
    const name = params['name'] as string;
    const flag = featureFlags.find((f) => f.name === name);
    return HttpResponse.json({ enabled: flag ? !!flag.enabled : false });
  }),
];
